const TOUCH_TARGET_PX = 44;

export default TOUCH_TARGET_PX;
